  <template>
        <!-- breadcrumb area start -->
    <div class="breadcrumb-area jarallax" style="background-image:url(/img/banner.png);">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <slot></slot>
                </div>
            </div>
        </div>
    </div>
    <!-- breadcrumb area End -->
</template>

<script>
export default {
  name: "BreadCrumb",
  
};
</script>


<style>

</style>



   